import { render, staticRenderFns } from "./DeleteTaskModal.vue?vue&type=template&id=3fdf5b6c&scoped=true&"
import script from "./DeleteTaskModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteTaskModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteTaskModal.vue?vue&type=style&index=0&id=3fdf5b6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdf5b6c",
  null
  
)

export default component.exports